import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=82714aa4&"
import script from "./attention.vue?vue&type=script&lang=js&"
export * from "./attention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports